
const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;

const PUBLIC_PATHS = ['/LoginPage', '/SignupPage', '/ForgotPassword'];

let loggingOut = false;
let refreshPromise = null;

// Captured at module-eval time, before authSessionGuard.js (which imports
// this module first) patches window.fetch — so the refresh call itself
// never re-enters the 401-retry logic.
const originalFetch = window.fetch.bind(window);

export function forceLogout() {
    if (loggingOut) return;
    if (PUBLIC_PATHS.includes(window.location.pathname)) return;
    loggingOut = true;

    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('role');
    localStorage.removeItem('permissions');
    localStorage.removeItem('is_superuser');
    localStorage.removeItem('all_role_codes');
    localStorage.removeItem('full_name');

    window.location.href = '/LoginPage';
}

export function refreshAccessToken() {
    if (refreshPromise) return refreshPromise;

    refreshPromise = (async () => {
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) return false;
        try {
            const res = await originalFetch(`${backendUrl}login/token/refresh/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ refresh: refreshToken }),
            });
            if (!res.ok) return false;
            const data = await res.json();
            if (!data.access) return false;
            localStorage.setItem('access_token', data.access);
            // Backend has ROTATE_REFRESH_TOKENS enabled: each refresh also
            // returns a new refresh token with a fresh 7-day countdown. Store
            // it so the session keeps extending as long as the user stays
            // active at least once every 7 days; without this the rotated
            // token would be silently discarded and the original login's
            // fixed 7-day clock would still apply.
            if (data.refresh) {
                localStorage.setItem('refresh_token', data.refresh);
            }
            return true;
        } catch (e) {
            return false;
        }
    })();

    refreshPromise.finally(() => { refreshPromise = null; });
    return refreshPromise;
}
